var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Reglas del Cliente")]),_vm._v(" "),_c('table-client-rules',{attrs:{"client_id":_vm.client_id}}),_vm._v(" "),_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }